// src/services/emailService.ts

export interface EmailConfirmationData {
  email: string;
  name: string;
  type: 'quote' | 'carrier';
  isUpdate: boolean;
  formData: any;
}

export const sendRequestConfirmation = async (data: EmailConfirmationData): Promise<boolean> => {
  try {
    console.log('📧 Sending confirmation email with data:', data);
    
    const response = await fetch('/.netlify/functions/send-request-confirmation', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        // Incluir el secret si está disponible en el entorno
        ...(process.env.REACT_APP_NOTIFICATION_SECRET && {
          'X-Notification-Secret': process.env.REACT_APP_NOTIFICATION_SECRET
        })
      },
      body: JSON.stringify(data),
    });

    console.log('📧 Response status:', response.status);
    console.log('📧 Response headers:', response.headers);

    if (!response.ok) {
      const errorText = await response.text();
      console.error('❌ Failed to send confirmation email:', response.status, response.statusText);
      console.error('❌ Error response body:', errorText);
      return false;
    }

    const result = await response.json();
    console.log('✅ Confirmation email sent successfully:', result.message);
    return true;
  } catch (error) {
    console.error('❌ Error sending confirmation email:', error);
    return false;
  }
};